export default __webpack_public_path__ + "static/media/go_back.174f8763.svg";